// Library Methods
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  ThemeProvider as LightThemeProvider,
  useTheme,
} from "@mui/material/styles";

// Styles
import {
  PageContainerWrapper,
  getSurfaceTokens,
} from "src/styles/mui/muiStylesHelper";

// Config
import { priorityLanguageMap } from "src/config/languages";

// Utils
import { setupTheme } from "src/utils/theme/themeHelper";

const UnauthorizedPdf = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  // This page is always rendered on a fixed white background (it's shown in
  // print/PDF contexts), regardless of the app's light/dark setting — locking
  // it to the light theme keeps its text legible no matter what mode the rest
  // of the app is in.
  const languageKey = i18n.language as keyof typeof priorityLanguageMap;
  const lightTheme = useMemo(
    () => setupTheme(theme.direction, languageKey, "light"),
    [theme.direction, languageKey]
  );

  return (
    <LightThemeProvider theme={lightTheme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            ...PageContainerWrapper(),
            backgroundColor: "#FFF",
            // MuiTypography forces `color: inherit`, so plain text only
            // picks up a theme's palette via CSS inheritance — the nested
            // LightThemeProvider above doesn't touch that chain by itself,
            // so it must be seeded here explicitly for it to cascade.
            color: getSurfaceTokens().onSurface,
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            py={10}
            px="24px"
            gap="24px"
            textAlign="center"
          >
            <Typography fontSize="24px" fontWeight={600}>
              {t("Error!")}
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Typography fontSize="20px">
                {t("Unauthorized Request.")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </LightThemeProvider>
  );
};

export default UnauthorizedPdf;
